@if (state) {
  <div [class]="containerClasses" role="status" aria-live="polite">
    <div class="snackbar__body">
      @if (state.config.icon) {
        <app-icon class="snackbar__icon">{{ state.config.icon }}</app-icon>
      }
      <span class="snackbar__message">{{ state.config.message }}</span>
    </div>
    @if (state.config.action) {
      <app-button variant="none" class="snackbar__action" (click)="onAction()">
        {{ state.config.action }}
      </app-button>
    }
  </div>
}
